import {PageTitle} from '../../_metronic/layout/core'
import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {
  actionCreateCurriculum,
  actionGetCurriculumById,
  actionUpdateCurriculum,
} from '../../redux/education'
import {
  callbackProps,
  curriculumInitial,
  CurriculumTypeEnum,
  curriculumValidations,
  DetailQueryState,
  ICurriculum,
  ICurriculumDetail,
  IStory,
  reduxProps,
} from '../../constants'
import {useDispatch, useSelector} from 'react-redux'
import {StoryList} from '../story/story-list'
import {useFormik} from 'formik'
import {StoryItem} from '../story/story-item'
import { toast } from "react-toastify";

export function CurriculumDetail() {
  const navigate = useNavigate()
  const [curriculumData, setCurriculumData] = useState<ICurriculum>(curriculumInitial)
  const [selectedStories, setSelectedStories] = useState<IStory[]>([])
  const [selectedStoryIds, setSelectedStoryIds] = useState<number[]>([])
  const {staffInfo} = useSelector((state: reduxProps) => state.authReducer)
  const {stories, classroom} = useSelector((state: reduxProps) => state.educationReducer)

  const {id} = useParams<DetailQueryState>()
  const dispatch = useDispatch()

  useEffect(() => {
    console.log('stories', stories)
    if (id > 0) {
      dispatch(
        actionGetCurriculumById(id, (r) => {
          if (r.type === 'SUCCESS') {
            setCurriculumData(r.payload.data)
            let selectedStories: number[] = r.payload.data.curriculumDetail.map(
              (item: ICurriculumDetail) => {
                return item.storyId
              }
            )
            setSelectedStoryIds(selectedStories)
          }
        })
      )
    } else {
      setCurriculumData({
        languageCode: 'tr-TR',
        organizationId: staffInfo.organizationId,
        curriculumTypeId: CurriculumTypeEnum.USER_DEFINED,
        gradeLevelId: classroom.gradeLevelId,
        schoolId: classroom.schoolId,
        useAllSameGradeLevel: false,
        title: '',
        active: true,
        createdUserId: staffInfo.id,
        curriculumDetail: [],
      })
    }
  }, [id])

  const redirectPage = (a: callbackProps) => {
    if (a.type === 'SUCCESS') {
      navigate('/curriculum/' + a.payload.data.id)
    }
  }

  const {getFieldProps, submitForm,isValid} = useFormik({
    initialValues: curriculumData,
    validationSchema: curriculumValidations,
    enableReinitialize: true,
    onSubmit: (values: ICurriculum) => {
      values.curriculumDetail = selectedStoryIds.map((item)=>{
        return {
          curriculumId:id,
          storyId:item
        }
      })
      if (values.curriculumDetail.length ===0) {
        toast.error("Hikaye seçmelisiniz")
        return;
      }
      if (id && id > 0) {
        dispatch(actionUpdateCurriculum(values, redirectPage))
      } else {
        dispatch(actionCreateCurriculum(values, redirectPage))
      }
    },
  })

  const handleSetSelectedStoryId = (item: number) => {
    if (!selectedStoryIds.includes(item)) {
      setSelectedStoryIds((current) => [...current, item])
    } else {
      setSelectedStoryIds((current) => current.filter((curriculumId) => curriculumId !== item))
    }
  }

  useEffect(() => {
    setSelectedStories(stories.filter((item) => selectedStoryIds.includes(item.storyId)))
  }, [selectedStoryIds])

  return (
    <div>
      <PageTitle
        description={
          'Sınıflar için oluşturulmuş kitaplıklara yenisini ekleyebilir veya varolanları düzenleyebilirsiniz.'
        }
      >
        Kitaplık işlemleri
      </PageTitle>

      <div className='card card-custom mb-5 shadow'>
        <div className='card-body'>
          <div>
            <div className={'row'}>
              <div className={'col-md-8'}>
                <div className='row'>
                  <label className='col-form-label fw-bold' htmlFor='start'>
                    Kitaplık başlığı
                  </label>
                  <div className={'col-md-6'}>
                    <input type='text' {...getFieldProps('title')} className='form-control' />
                  </div>
                  <div className={'col-md-2 flex-column'}>
                    <button className='btn btn-education col-md-12' onClick={submitForm}>
                      Oluştur
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {selectedStories.length > 0 && (
              <div className={'row mt-5 d-flex'}>
                <div className={'col-md-10 story-list flex-column'}>
                  {selectedStories.map((storyItem, index) => {
                    return (
                      <StoryItem
                        item={storyItem}
                        index={index}
                        handleSetSelectedStoryId={handleSetSelectedStoryId}
                        checked={true}
                      />
                    )
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <StoryList
        handleSetSelectedStoryId={handleSetSelectedStoryId}
        selectedStoryIds={selectedStoryIds}
        showCurriculumDropdown={false}
        description={'Bu alandan oluşturmak istediğiniz müfradata kitap seçebilirsiniz.'}
      />
      <div className={'mt-5'}></div>
      <button onClick={submitForm} className='btn btn-primary' disabled={isValid}>
        {id ? 'Güncelle' : 'Oluştur'}
      </button>
    </div>
  )
}
